import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.137 2.254a2 2 0 0 1 1.684.435l.122.112L30 15.858a2 2 0 0 1 .119 2.698l-.119.13L18.686 30a2 2 0 0 1-2.698.119l-.13-.12L2.8 16.944a2 2 0 0 1-.572-1.642l.025-.164L4.271 5.055a1 1 0 0 1 .668-.754l.116-.03zm.392 1.961L6.1 6.1l-1.885 9.43 13.057 13.056 11.314-11.314zM12 10.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconCostCodes = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconCostCodes);
export default Memo;
